import gql from 'graphql-tag';
import deviceFragment from '../fragments/device';
import placeFragment from '../fragments/place';

const GET_DEVICES_BY_CUSTOMER = gql`
  query getDevicesByCustomer(
    $customerId: ID!
    $filter: DeviceFilterInput
    $sort: DeviceSortInput
    $skip: Int
    $take: Int
  ) {
    getDevicesByCustomer(
      customerId: $customerId
      filter: $filter
      sort: $sort
      skip: $skip
      take: $take
    ) {
      devices {
        ...deviceDetails
        devicePlaces {
          placeId
          place {
            ...placeDetails
          }
        }
        placeOpened
      }
      aggregate {
        rows
      }
    }
  }
  ${deviceFragment.FRAGMENT_DEVICE}
  ${placeFragment.FRAGMENT_PLACE}
`;

const GET_DEVICES_BY_CUSTOMERS = gql`
  query getDevicesByCustomers(
    $customerIds: [ID]!
    $filter: DeviceFilterInput
    $sort: DeviceSortInput
    $skip: Int
    $take: Int
  ) {
    getDevicesByCustomers(
      customerIds: $customerIds
      filter: $filter
      sort: $sort
      skip: $skip
      take: $take
    ) {
      devices {
        ...deviceDetails
        devicePlaces {
          placeId
          place {
            ...placeDetails
          }
        }
        placeOpened
      }
      aggregate {
        rows
      }
    }
  }
  ${deviceFragment.FRAGMENT_DEVICE}
  ${placeFragment.FRAGMENT_PLACE}
`;

const GET_DEVICES_BY_ID = gql`
  query GetDeviceById($id: ID!) {
    getDeviceById(id: $id) {
      ...deviceDetails
      devicePlaces {
        placeId
        place {
          ...placeDetails
        }
      }
      placeOpened
    }
  }
  ${deviceFragment.FRAGMENT_DEVICE}
  ${placeFragment.FRAGMENT_PLACE}
`;

const GET_AVAILABLE_CCTV_DEVICES_BY_PLACE_ID = gql`
  query GetAvailableCCTVDevicesByPlaceId($placeId: ID!) {
    getAvailableCCTVDevicesByPlaceId(placeId: $placeId) {
      id
      name
      workspacePrefixId
      workspacePrefix {
        id
        prefix
      }
      uniqueId
      type
      channels {
        id
        channelId
        description
        createdAt
        updatedAt
      }
    }
  }
`;

const GET_DEVICES_BY_IDS = gql`
  query getDevicesByIds($deviceIds: [ID!]!) {
    getDevicesByIds(deviceIds: $deviceIds) {
      ...deviceDetails
      devicePlaces {
        placeId
        place {
          ...placeDetails
        }
      }
      placeOpened
    }
  }
  ${deviceFragment.FRAGMENT_DEVICE}
  ${placeFragment.FRAGMENT_PLACE}
`;

const GET_DEVICES_SEARCH = gql`
  query getDevicesByWorkspace(
    $workspaceId: ID!
    $filter: DeviceFilterInput
    $sort: DeviceSortInput
    $skip: Int
    $take: Int
    $includeSharedWorkspaces: Boolean = false
  ) {
    getDevicesByWorkspace(
      workspaceId: $workspaceId
      filter: $filter
      sort: $sort
      skip: $skip
      take: $take
      includeSharedWorkspaces: $includeSharedWorkspaces
    ) {
      devices {
        id
        name
        uniqueId
        image
        workspacePrefix {
          prefix
        }
      }
    }
  }
`;

export default {
  GET_DEVICES_BY_CUSTOMER,
  GET_DEVICES_BY_ID,
  GET_DEVICES_BY_CUSTOMERS,
  GET_AVAILABLE_CCTV_DEVICES_BY_PLACE_ID,
  GET_DEVICES_BY_IDS,
  GET_DEVICES_SEARCH,
};
